// For custom Js that will render accross entire site
// Header
(function () {
    function initHeaderMenu() {
        let headerNavButtons = document.querySelectorAll('.header__link-button');
        let overlay = document.querySelector('.mega-menu-overlay');

        console.log('Init header menu - overlay found:', !!overlay);
        console.log('Header nav buttons found:', headerNavButtons.length);

        // Create overlay if it doesn't exist
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'mega-menu-overlay';
            document.body.appendChild(overlay);
            console.log('Overlay created and added to body');
        } else if (!overlay.hasAttribute('data-moved')) {
            // Move overlay to body to escape stacking context
            document.body.appendChild(overlay);
            overlay.setAttribute('data-moved', 'true');
            console.log('Overlay moved to body');
        }

        // Add direct click listener to overlay to close menu
        if (overlay && !overlay.hasAttribute('data-click-listener')) {
            overlay.addEventListener('click', function(e) {
                console.log('Overlay clicked directly - closing all menus');

                // Close all menus
                headerNavButtons.forEach(item => {
                    item.classList.remove('active');
                    item.setAttribute('aria-expanded', 'false');
                    item.closest('.header__desktop-menu-li').classList.remove('open');
                });

                // Hide overlay
                overlay.classList.remove('active');
                overlay.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; pointer-events: none !important;';

                console.log('Menu closed and overlay hidden via overlay click');
            });
            overlay.setAttribute('data-click-listener', 'true');
            console.log('Click listener added to overlay');
        }

        headerNavButtons.forEach((button, index) => {
            // Get submenu wrapper
            let submenu = button.closest('.header__desktop-menu-li').querySelector('.submenu');

            if (submenu) {
                // Ensure submenu has an ID (auto-generate if missing)
                if (!submenu.id) {
                    submenu.id = `submenu-${index + 1}`;
                }
                // Link aria-controls
                button.setAttribute('aria-controls', submenu.id);
            }

            // Initialize aria-expanded
            button.setAttribute('aria-expanded', 'false');

            button.addEventListener('click', () => {
                let isActive = button.classList.contains('active');
                console.log('Button clicked, isActive:', isActive);

                // Close all first
                headerNavButtons.forEach(item => {
                    item.classList.remove('active');
                    item.setAttribute('aria-expanded', 'false');
                    item.closest('.header__desktop-menu-li').classList.remove('open');
                });

                // Remove overlay
                if (overlay) {
                    overlay.classList.remove('active');
                    overlay.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; pointer-events: none !important;';
                    console.log('Overlay hidden via button toggle');
                }

                // Toggle this one
                if (!isActive) {
                    button.classList.add('active');
                    button.setAttribute('aria-expanded', 'true');
                    button.closest('.header__desktop-menu-li').classList.add('open');

                    // Show overlay (only on desktop)
                    if (overlay && window.innerWidth >= 1024) {
                        overlay.classList.add('active');
                        // Force display with inline styles
                        overlay.style.cssText = 'display: block !important; position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; background-color: rgba(0, 0, 0, 0.5) !important; z-index: 998 !important; opacity: 1 !important; visibility: visible !important; pointer-events: auto !important;';
                        console.log('Overlay shown');
                        console.log('Overlay in DOM:', document.body.contains(overlay));
                    }
                }
            });
        });
    }

    function closeDesktopMenuonFocusOut() {
        function closeMenus() {
            console.log('closeMenus called');

            let headerNavButtons = document.querySelectorAll('.header__link-button');
            let overlay = document.querySelector('.mega-menu-overlay');

            // Close all menus
            headerNavButtons.forEach(item => {
                item.classList.remove('active');
                item.setAttribute('aria-expanded', 'false');
                item.closest('.header__desktop-menu-li').classList.remove('open');
            });

            // Force hide overlay with multiple methods
            if (overlay) {
                console.log('Hiding overlay - before:', {
                    display: overlay.style.display,
                    opacity: overlay.style.opacity,
                    classes: overlay.className
                });

                // Remove active class
                overlay.classList.remove('active');

                // Set inline styles to force hide
                overlay.style.cssText = 'display: none !important; opacity: 0 !important; visibility: hidden !important; pointer-events: none !important;';

                console.log('Overlay hidden - after:', {
                    display: overlay.style.display,
                    opacity: overlay.style.opacity,
                    classes: overlay.className
                });
            } else {
                console.log('Overlay not found in DOM');
            }
        }

        // Close on any click outside the menu
        document.addEventListener('click', function (event) {
            let openMenuItem = document.querySelector('.header__desktop-menu-li.open');

            // If no menu is open, do nothing
            if (!openMenuItem) return;

            let overlay = document.querySelector('.mega-menu-overlay');
            let clickedInsideMenu = openMenuItem.contains(event.target);
            let clickedOnOverlay = overlay && event.target === overlay;

            console.log('Document click detected:', {
                clickedOnOverlay,
                clickedInsideMenu,
                targetClass: event.target.className,
                targetTag: event.target.tagName
            });

            // Don't close if clicking inside the menu (unless it's on the overlay)
            // The overlay has its own click handler
            if (!clickedInsideMenu && !clickedOnOverlay) {
                console.log('Click outside menu - closing');
                closeMenus();
            }
        }, true); // Use capture phase to catch event early

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                console.log('Escape pressed, closing menu');
                closeMenus();
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            closeDesktopMenuonFocusOut();
            initHeaderMenu();
        });
    } else {
        closeDesktopMenuonFocusOut();
        initHeaderMenu();
    }
})();


// accordions
(function(){
    function initAccordions(){
        const accordions = document.querySelectorAll('.accordion-wrapper');
        accordions.forEach(accordion =>{
            accordion.addEventListener('click',()=>{
                accordion.classList.toggle('open');
            })
        })
    }

    initAccordions()
})();